<script setup>
import useReportes from "@/composables/useReportes";
import PaginationComponent from "@/components/PaginationComponent";
import NoDataComponent from "@/components/NoDataComponent";
import useStoreCotizaciones from "@/store/cotizaciones";

const { plazoTotal } = useStoreCotizaciones();

const {
  listaCotizaciones,
  fetchInitialReportes,
  getData,
  dataCargada,
  searchingData,
  searchData,
  noRecords,
} = useReportes();

fetchInitialReportes();
</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex flex-row align-items-center mb-3">
              <h6 class="mb-0">Reporte cotizaciones</h6>
            </div>
          </div>
          <div class="card-body">
            <form id="formReporte" @submit.prevent="searchData">
              <div class="row">
                <div class="form-group col-md-3 px-1">
                  <label for="estatus">Estatus:</label>
                  <select name="estatus" id="estatus" class="form-control">
                    <option value="">Seleccione</option>
                    <option value="PENDIENTE">PENDIENTE</option>
                    <option value="APROBADA">APROBADA</option>
                    <option value="RECHAZADA">RECHAZADA</option>
                  </select>
                </div>
                <div class="form-group col-md-3 px-1">
                  <label for="linea">Línea:</label>
                  <select name="linea" id="linea" class="form-control">
                    <option value="">Seleccione</option>
                    <option value="AZUL">AZUL</option>
                    <option value="PLATINO">PLATINO</option>
                  </select>
                </div>
                <div class="form-group col-md-3 px-1">
                  <label for="fecha_inicio">Fecha inicio:</label>
                  <input
                    type="date"
                    class="form-control"
                    id="fecha_inicio"
                    name="fecha_inicio"
                    required
                  />
                </div>
                <div class="form-group col-md-3 px-1">
                  <label for="fecha_fin">Fecha fin:</label>
                  <input
                    type="date"
                    class="form-control"
                    id="fecha_fin"
                    name="fecha_fin"
                    required
                  />
                </div>
                <div class="form-group col-md-3">
                  <button class="btn bg-gradient-primary btn-xs mb-0">
                    <span
                      v-if="searchingData"
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="ri-search-2-line me-1 fs-6"
                      v-if="!searchingData"
                    ></i>
                    Buscar
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="card-header pb-1 border-bottom">
            <div class="d-flex flex-row align-items-center mb-3">
              <h6 class="mb-0">Cotizaciones generadas</h6>
            </div>
          </div>
          <div class="card-body py-5">
            <div class="d-flex justify-content-center" v-if="!dataCargada">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <NoDataComponent v-else-if="noRecords" />
            <div class="table-responsive" v-else>
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Cliente
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Empresa
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Importe/Enganche
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Línea
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Estatus
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="cotizacion in listaCotizaciones.data"
                    :key="cotizacion.id"
                  >
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <div
                            class="icon icon-shape icon-sm me-3 bg-gradient-info shadow text-center"
                          >
                            <i class="ri-book-2-line text-white opacity-10"></i>
                          </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-xs">
                            {{ cotizacion.nombre_cliente }}
                          </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ cotizacion.empresa }}
                          </p>
                          <p class="text-xs text-secondary mb-0">
                            RFC: {{ cotizacion.rfc }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">
                        <h6 class="mb-0 text-xs">
                          {{ cotizacion.arrendamiento_tipo }}
                        </h6>
                        <p class="text-xs text-lowercase text-secondary mb-0">
                          {{ cotizacion.residencia }}
                        </p>
                        <p class="text-xs text-lowercase text-secondary mb-0">
                          Tel: {{ cotizacion.telefono }}
                        </p>
                      </span>
                    </td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">
                        <h6 class="mb-0 text-xs">
                          I: ${{ cotizacion.importe }}
                        </h6>
                        <p class="text-xs text-secondary mb-0">
                          E: ${{ cotizacion.enganche_monto }}
                        </p>
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        v-if="cotizacion.linea == 'AZUL'"
                        class="badge badge-sm bg-gradient-info"
                        >Azul</span
                      >
                      <span
                        v-else
                        class="badge badge-sm bg-gradient-light text-dark opacity-9"
                        >Platino</span
                      >
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        v-if="cotizacion.estatus == 'APROBADA'"
                        class="badge badge-sm bg-gradient-success"
                        >Aprobada</span
                      >
                      <span
                        v-else-if="cotizacion.estatus == 'RECHAZADA'"
                        class="badge badge-sm bg-gradient-danger"
                        >Rechazada</span
                      >
                      <span v-else class="badge badge-sm bg-gradient-secondary"
                        >Pendiente</span
                      >
                    </td>
                    <td class="align-middle text-center" width="140">
                      <router-link
                        :to="{
                          name: 'cotizacion-show',
                          params: { token: cotizacion.token },
                          query: { plazo: plazoTotal() },
                        }"
                        class="btn btn-link text-secondary text-xs mb-0"
                      >
                        <i class="ri-file-line me-1"></i>
                        Ver formato
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 px-4">
                <pagination-component
                  :current-page="listaCotizaciones.current_page"
                  :last-page="listaCotizaciones.last_page"
                  @page-change="getData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
